module.exports = __webpack_public_path__ + "img/book_record.327d26bb.svg";